module.exports = __webpack_public_path__ + "static/media/screenshot-whonext.88e27d5b.png";